











































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as models from '@/api/models';
import * as api from '@/api';
import dutyUnit from '@/components/dutyUnit.vue';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { downloadBlob } from '@/utils/util';
import { datetime } from '@/utils/filter';
import { State } from 'vuex-class';
import { IUserSession } from '@/store/modules/session';
import { message } from 'ant-design-vue';

@Component({ components: { dutyUnit } })
export default class YqManage extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;
  thems = ['原文链接一', '原文链接二', '原文链接三'];
  listData = [];
  eventList = [
    {
      id: 1,
      name: '分类一',
    },
    {
      id: 2,
      name: '分类二',
    },
  ];
  listQuery = {
    reportState: '',
    keyword: '',
    summary: '',
    theme: '',
    isBd: undefined,
    unitInvolved: '',
    postedBy: '',
    publisher: '',
    source: '',
    yqSource: '',
    place: '',
    area: '',
    eventId: undefined,
    startPublishTime: '',
    endPublishTime: '',
    startCreationTime: '',
    endCreationTime: '',
  };
  pagination = {
    current: 1,
    defaultPageSize: 30,
    showQuickJumper: true,
    total: 0,
    showTotal: () => `总记录数 ${this.pagination.total}`,
  };

  async stateChange(val: number, record: any) {
    // 设置加载状态
    this.$set(record, 'statusLoading', true);

    try {
      const data = await api.Yq.sumbitDealWithResult_POST({
        id: record.Id,
        dealState: val,
        result: record.DealWithResult,
      });

      if (data && data.success) {
        this.$message.success('处置状态更新成功');
      } else {
        this.$message.error(data?.message || '更新失败');
        // 如果失败，恢复原状态
        // 这里需要从数据源恢复，或者重新获取数据
      }
    } catch (err) {
      this.$message.error('保存处置状态失败');
      // 如果失败，恢复原状态
      this.fetchData(this.pagination.current);
    } finally {
      this.$set(record, 'statusLoading', false);
    }
  }

  getSelectStyle(dealState: number) {
    const baseStyle = {
      width: '120px',
    };

    switch (dealState) {
      case 0:
        return {
          ...baseStyle,
          backgroundColor: '#fff2f0',
          borderColor: '#ffccc7',
          color: 'red',
        };
      case 1:
        return {
          ...baseStyle,
          backgroundColor: '#fff7e6',
          borderColor: '#ffd591',
          color: '#fadb14',
        };
      case 2:
        return {
          ...baseStyle,
          backgroundColor: '#f6ffed',
          borderColor: '#b7eb8f',
          color: 'green',
        };
      default:
        return baseStyle;
    }
  }

  async submitResult(row: any) {
    if (!row.DealWithResult) {
      this.$message.error('请输入处置情况');
      return;
    }
    const data = await api.Yq.sumbitDealWithResult_POST({
      id: row.Id,
      result: row.DealWithResult,
      dealState: row.DealState,
    });

    if (data && data.success) {
      this.$message.success('提交成功');
    } else {
      this.$message.success(data.message);
    }
  }
  async exportList() {
    const h = this.$message.loading('正在下载文件');
    api.Yq.exportDeptYq_GET({
      isPositive: this.currentSession.deptName == '共青团广西区委' ? false : null,
      reportState: this.listQuery.reportState == '' ? null : this.listQuery.reportState == 'true',
      eventCategoryId: null,
      keyword: this.listQuery.keyword,
      theme: this.listQuery.theme,
      publisher: this.listQuery.publisher,
      source: this.listQuery.source,
      startPublishTime: this.listQuery.startPublishTime
        ? new Date(new Date(new Date(this.listQuery.startPublishTime).toLocaleDateString()).getTime())
        : null,
      endPublishTime: this.listQuery.endPublishTime
        ? new Date(
            new Date(new Date(this.listQuery.endPublishTime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          )
        : null,
      startCreationTime: this.listQuery.startCreationTime
        ? new Date(new Date(new Date(this.listQuery.startCreationTime).toLocaleDateString()).getTime())
        : null,
      endCreationTime: this.listQuery.endCreationTime
        ? new Date(
            new Date(new Date(this.listQuery.endCreationTime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          )
        : null,
    })
      .then(data => {
        downloadBlob(data, ('舆情日报-' + datetime(Date.now(), 'YYYY-MM-DD') + '.xlsx') as string);
        h();
      })
      .catch(err => {
        this.$message.error(err.message);
        h();
      });
  }
  search() {
    this.fetchData();
  }
  // 处理页码变化
  async handlePageChange(page: number = 1) {
    this.fetchData(page);
  }
  async fetchData(page: number = 1) {
    this.pagination.current = page;
    const data: any = await api.Yq.getAll_GET({
      isPositive: this.currentSession.deptName == '共青团广西区委' ? false : null,
      reportState: this.listQuery.reportState == '' ? null : this.listQuery.reportState == 'true',
      eventCategoryId: null,
      keyword: this.listQuery.keyword,
      theme: this.listQuery.theme,
      publisher: this.listQuery.publisher,
      source: this.listQuery.source,
      startPublishTime: this.listQuery.startPublishTime
        ? new Date(new Date(new Date(this.listQuery.startPublishTime).toLocaleDateString()).getTime())
        : null,
      endPublishTime: this.listQuery.endPublishTime
        ? new Date(
            new Date(new Date(this.listQuery.endPublishTime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          )
        : null,
      startCreationTime: this.listQuery.startCreationTime
        ? new Date(new Date(new Date(this.listQuery.startCreationTime).toLocaleDateString()).getTime())
        : null,
      endCreationTime: this.listQuery.endCreationTime
        ? new Date(
            new Date(new Date(this.listQuery.endCreationTime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          )
        : null,
      size: 30,
      p: page,
    });
    this.listData = data.data.Items;
    this.pagination.total = data.data.TotalCount ? data.data.TotalCount : 0;
  }

  mounted() {
    this.fetchData();
  }
}
